export default require('./Image').default
